<template>
	<AppLayout
		:title="trans('events.edit.title', {title: event.title})"
		:subtitle="subtitle"
		:return-url="returnUrl ?? route(`events.${event.type}.index`)"
		:return-label="returnLabel ?? trans(`menu.events.${event.type}`)"
	>
		<template #actions>
			<slot name="actions"/>
		</template>
		<slot/>
	</AppLayout>
</template>
<script setup lang="ts">
import {route} from 'ziggy-js'
import {defineProps} from 'vue'
import {trans} from 'laravel-vue-i18n'
import {type Event} from '@/Types/Events/Event'
import AppLayout from '@/Layouts/AppLayout.vue'

defineProps<{
	event:Event,
	subtitle?:string,
	returnUrl?:string,
	returnLabel?:string,
}>()
</script>